// Created by hejikun on 2017/11/2 0002.
let home = [
  {
    path: '/home_recommend_doctor_list',
    name: '推荐医生',
    component: () => import('@/pages/home/home_recommend_doctor_list')
  },
  {
    path: '/home_my_doctors',
    name: '我的医生',
    component: () => import('@/pages/home/home_my_doctors')
  },
  {
    path: '/home_fee',
    name: '在线缴费',
    component: () => import('@/pages/home/home_fee')
  },
  {
    path: '/home_fee_v3',
    name: '在线缴费',
    component: () => import('@/pages/home/home_fee_v3')
  },
  {
    path: '/home_report',
    name: '报告查询',
    component: () => import('@/pages/home/home_report')
  },
  {
    path: '/home_report_v3',
    name: '报告查询',
    component: () => import('@/pages/home/home_report_v3')
  },
  {
    path: '/home2',
    name: '滇医通',
    component: () => import('@/pages/home/home')
  },
  {
    path:'/notice',
    name:'公告',
    component: () => import('@/pages/home/notice')
  }
]

export default home
